import React from 'react';
import ReactDOM from 'react-dom';
import * as styles from './ContextHelp.css.ts';

interface ContextHelpOverlayProps {
  helpContent: React.ReactNode;
  onClose: () => void;
}

export const ContextHelpOverlay: React.FC<ContextHelpOverlayProps> = ({
  helpContent,
  onClose
}) => {

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div
      className={styles.helpOverlay}
      onClick={handleBackdropClick}
    >
      <div className={styles.helpOverlayContent}>
        <button
          className={styles.helpOverlayClose}
          onClick={onClose}
          aria-label="Close help"
        >
          ✕
        </button>
        <div className={styles.helpContent}>
          {helpContent}
        </div>
      </div>
    </div>,
    document.body
  );
};